import { useQuery } from '@apollo/react-hooks';
import OpModel from '@opsbase/lib-data-model/models/OpModel';
import Palette from '@opsbase/lib-palette';
import { getStoredValue, setStoredValue } from '@opsbase/lib-storage';
import useCss from '@opsbase/web-css';
import Pane from '@opsbase/web-layout/Pane';
import useParams from '@opsbase/web-nav/useParams';
import gql from 'graphql-tag';
import React, { useEffect, useMemo, useRef } from 'react';
import ReportCoverPage from '../../ReportCoverPage';
import { getDetailsReportDefinition } from '../DetailsReportDefinition';
import DetailsOpReportContext from './DetailsOpReportContext';
import DetailsOpReportConversations from './DetailsOpReportConversations';
import DetailsOpReportIssues from './DetailsOpReportIssues';
import DetailsOpReportResponses from './DetailsOpReportResponses';
import DetailsOpReportSummary from './DetailsOpReportSummary';
const makeMyClasses = pdf => ({
    root: {
        margin: pdf ? undefined : 'auto',
        marginTop: pdf ? undefined : 10,
        maxWidth: pdf ? undefined : 700,
        backgroundColor: 'white',
        color: Palette.BlackCoral.main,
        fontFamily: 'Gilroy',
    },
});
const query = gql `
	query GetOpDetailsReportData($id: String!, $organisationId: String!, $stamp: String!) {
		opDetailsReportData(id: $id, organisationId: $organisationId, stamp: $stamp) {
			id
			title
			description
			startFrom
			completeBy
			actualStart
			actualComplete
			hasImage
			form
			isScoreEnabled
			gradingMethod
			grade
			passFailStatus
			completedOnDeviceType
			place {
				__typename
				id
				title
				timezone
			}
			teams {
				__typename
				id
				title
			}
			positions {
				__typename
				id
				title
			}
			allPTsPermitted
			opDefinitionId
			opScheduleId
			organisation {
				__typename
				id
				title
				settings
			}
			submittedBy {
				__typename
				id
				title
				profileImageUrl
				hasProfileImage
			}
			startedBy {
				__typename
				id
				title
				profileImageUrl
				hasProfileImage
			}
			conversations {
				__typename
				id
				title
				messages
				participants {
					id
					title
					hasProfileImage
					profileImageUrl
				}
			}
			issues {
				__typename
				id
				title
				flag
				type
				status
				occurrenceDate
				deadlineDate
				closedDate
				updatedDate
				comments
				place {
					__typename
					id
					title
					timezone
				}
				createdBy {
					__typename
					id
					title
				}
				assignedToSPTType
				assignedToStaff {
					__typename
					id
					title
				}
				assignedToPosition {
					__typename
					id
					title
				}
				assignedToTeam {
					__typename
					id
					title
				}
				commentors {
					__typename
					id
					title
				}
				causes
				correctiveActions
				preventativeActions
			}
			opPerformedLocation
		}
	}
`;
export function DetailsOpReportPage() {
    var _a, _b;
    const { key } = useParams();
    const { id, organisationId, stamp, token } = getDetailsReportDefinition(key);
    const hasTokenStored = useRef(false);
    useEffect(() => {
        if (getStoredValue('accessToken') !== token)
            setStoredValue('accessToken', token);
        hasTokenStored.current = true;
    }, [token]);
    const { loading, data: opData } = useQuery(query, {
        variables: {
            id,
            organisationId,
            stamp,
        },
        skip: !hasTokenStored.current,
    });
    const op = useMemo(() => ((opData === null || opData === void 0 ? void 0 : opData.opDetailsReportData) ? new OpModel(opData === null || opData === void 0 ? void 0 : opData.opDetailsReportData) : null), [opData]);
    const def = getDetailsReportDefinition(key);
    const myCss = useCss(makeMyClasses, [def.pdf]);
    const ctx = useMemo(() => {
        const form = op === null || op === void 0 ? void 0 : op.getParsedForm();
        // let issues = []
        // let notes = []
        // if (form) {
        // 	const qs = getEnabledQuestions(
        // 		form.questionTree,
        // 		z => !form.answers[z.nodeId]?.notApplicable
        // 	)
        // 	issues = qs
        // 		.map(q => form.answers[q.nodeId].issueId)
        // 		.filter(v => !!v)
        // 		.map(v => op.issues.find(i => i.id === v))
        // 		.filter(v => !!v)
        // 	notes = qs
        // 		.map(q => form.answers[q.nodeId].conversationId)
        // 		.filter(v => !!v)
        // 		.map(v => op.conversations.find(i => i.id === v))
        // 		.filter(v => !!v)
        // }
        return {
            op,
            form,
            def,
            issues: op === null || op === void 0 ? void 0 : op.issues,
            notes: op === null || op === void 0 ? void 0 : op.conversations,
        };
    }, [op, def]);
    if (!ctx.op || loading)
        return null;
    return (React.createElement(DetailsOpReportContext.Provider, { value: ctx },
        React.createElement(Pane, { classes: { root: myCss.root }, padding: !def.pdf },
            React.createElement(ReportCoverPage, { title: ctx.op.title, subTitle: ctx.op.organisation.title, description: ctx.op.description, logoId: (_a = ctx.op.organisation.settings) === null || _a === void 0 ? void 0 : _a.logoId, titleColor: (_b = ctx.op.organisation.settings) === null || _b === void 0 ? void 0 : _b.titleColor, pdf: def.pdf }),
            React.createElement(DetailsOpReportSummary, null),
            React.createElement(DetailsOpReportResponses, null),
            ctx.issues.length > 0 && React.createElement(DetailsOpReportIssues, null),
            ctx.notes.length > 0 && React.createElement(DetailsOpReportConversations, null))));
}
export default DetailsOpReportPage;
